import { Box } from "@mui/material";
import { BoxProps } from "@mui/system";

export interface IHoverCardProps extends BoxProps {
    href?: string;
}

export const HoverCard = ({ children, sx, ...props }: IHoverCardProps) => {
    return (
        <Box
            {...props}
            sx={[
                {
                    display: "flex",
                    padding: 2,
                    bgcolor: "white",
                    boxShadow: 2,
                    borderRadius: 1,
                    cursor: "pointer",
                    transition: "all 0.2s",
                    "&:hover": { boxShadow: 6, transform: "scale(1.02)", zIndex: 1 },
                    "&:active": { transform: "scale(1)" },
                },
                ...(Array.isArray(sx) ? sx : [sx]),
            ]}
        >
            {children}
        </Box>
    );
};
